import { createBrowserRouter } from 'react-router';
import { RootLayout } from './components/RootLayout';
import { ContactPage } from './pages/Contact';
import { DesignPage } from './pages/Design';
import { HomePage } from './pages/Home';
import { NotFoundPage } from './pages/NotFound';
import { PrivacyPage } from './pages/Privacy';
import { StudioPage } from './pages/Studio';
import { WorkDetailPage } from './pages/WorkDetail';
import { WorksPage } from './pages/Works';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: HomePage },
      { path: 'lavori', Component: WorksPage },
      { path: 'lavori/:slug', Component: WorkDetailPage },
      { path: 'design', Component: DesignPage },
      { path: 'studio', Component: StudioPage },
      { path: 'contatti', Component: ContactPage },
      { path: 'privacy', Component: PrivacyPage },
      { path: '*', Component: NotFoundPage },
    ],
  },
]);
